"use client";

import React from "react";
import PostMeta from "../PostMeta/PostMeta";
import SocialShare from "../SocialShare/SocialShare";
import "./PostMetaWithShare.scss";

export interface PostMetaWithShareProps {
  publishedAt: string | Date;
  viewCount?: number;
  title: string;
  url?: string;
  className?: string;
  layout?: "row" | "column";
}

/**
 * PostMetaWithShare Component
 * Combines PostMeta and SocialShare components
 */
export default function PostMetaWithShare({
  publishedAt,
  viewCount,
  title,
  url,
  className = "",
  layout = "row",
}: PostMetaWithShareProps) {
  return (
    <div className={`post-meta-with-share post-meta-with-share--${layout} ${className}`}>
      <PostMeta publishedAt={publishedAt} viewCount={viewCount} />
      <SocialShare title={title} url={url} />
    </div>
  );
}
